import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { ServiceLocator } from '../../app/ServiceLocator';
import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import {apiPerformanceTimer, HomeApiResult} from '../../home/utils/ApiPerformanceTimer';
import { ChannelTypes } from '../../home/types/ChannelTypes';
import { generateUuid } from '../../home/utils/uuidGenerator';
import {
GetAllWorkbookStartersRequest,
GetAllWorkbookStartersResult
} from '../../ts/ServerApi/starters/requests/GetAllWorkbookTemplatesRequest';
import { ServerService } from '../../ts/services/ServerService';
import {
  FetchStarterInfoRequested,
  fetchStarterInfoRequestedAction,
  fetchStartersSucceededAction,
  isFetchStartersInfoRequestedAction
} from '../actions/StartersActions';

export function* rootStartersSaga(): SagaIterator {
  yield takeEvery(fetchStarterInfoRequestedAction, handleGetStartersInfoAction);
}

export const getStartersFromState = (state: AppState) => state.starters;

export function* handleGetStartersInfoAction(action: FetchStarterInfoRequested): SagaIterator {
  try {
    if (isFetchStartersInfoRequestedAction(action)) {
      const uuid = generateUuid();
      const result = yield call(apiPerformanceTimer, fetchStartersWithPerformanceTimer, ChannelTypes.starters, uuid);
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function* fetchStartersWithPerformanceTimer(result: HomeApiResult){
   const startersContent: GetAllWorkbookStartersResult = yield call(sendGetServerStartersInfoRequest);
   yield put(fetchStartersSucceededAction(startersContent));
   result.contentLength = startersContent.workbookTemplates.length;
}

export function sendGetServerStartersInfoRequest(): ng.IPromise <GetAllWorkbookStartersResult> {
  const serverService = ServiceLocator.get<ServerService>('ServerService');
  const result = serverService.sendRequest(new GetAllWorkbookStartersRequest());
  return result;
}
